export default __webpack_public_path__ + "static/media/vote0.02c45600.png";